module.exports = __webpack_public_path__ + "static/img/barra_1.2be73b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/barra_1.png
// module id = g+VX
// module chunks = 1